import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ScreenSizeType, BreakpointType, DeviceType, OrientationType } from './responsive.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  // private _isSidenavOpen = true;
  private _isHandset = new BehaviorSubject<boolean>(false);
  private _isTablet = new BehaviorSubject<boolean>(false);
  private _isMedium = new BehaviorSubject<boolean>(false);
  public isHandset$ = this._isHandset.asObservable();
  public isTablet$ = this._isTablet.asObservable();
  public isMedium$ = this._isMedium.asObservable();

  private _isSidenavOpened = new BehaviorSubject<boolean>(true);
  public isSidenavOpened$ = this._isSidenavOpened.asObservable();
  constructor(breakpointObserver: BreakpointObserver) {
    this.checkScreenSize(breakpointObserver);

    this.checkDeviceTypeAndOrientation(breakpointObserver);
  }

  private _screenSize = ScreenSizeType.Unknown;
  public get screenSize(): ScreenSizeType {
    return this._screenSize;
  }

  private readonly screenSizeBreakpoints = new Map([
    [Breakpoints.XSmall, ScreenSizeType.XSmall],
    [Breakpoints.Small, ScreenSizeType.Small],
    [Breakpoints.Medium, ScreenSizeType.Medium],
    [Breakpoints.Large, ScreenSizeType.Large],
    [Breakpoints.XLarge, ScreenSizeType.XLarge],
  ]);

  private checkScreenSize(breakpointObserver: BreakpointObserver): void {
    breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe((result: any) => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this._screenSize = this.screenSizeBreakpoints.get(query) ?? ScreenSizeType.Unknown;

            if (this._screenSize === ScreenSizeType.XSmall) {
              this._isHandset.next(true);
            } else {
              this._isHandset.next(false);
            }
            if (this._screenSize === ScreenSizeType.Small) {
              this._isTablet.next(true);
            } else {
              this._isTablet.next(false);
            }
            if (this._screenSize === ScreenSizeType.Medium) {
              this._isMedium.next(true);
            } else {
              this._isMedium.next(false);
            }
            if (
              this._screenSize === ScreenSizeType.XSmall ||
              this._screenSize === ScreenSizeType.Small ||
              this._screenSize === ScreenSizeType.Medium
            ) {
              // this._isSidenavOpen = false;
              this._isSidenavOpened.next(false);
            } else {
              // this._isSidenavOpen = true;
              this._isSidenavOpened.next(true);
            }
          }
        }
      });
  }

  public orientationPortrait(): boolean {
    return this._orientation === OrientationType.Portrait;
  }
  public orientationLandscape(): boolean {
    return this._orientation === OrientationType.Landscape;
  }

  public deviceDesktop(): boolean {
    return this._deviceType === DeviceType.Web;
  }
  public deviceTablet(): boolean {
    return this._deviceType === DeviceType.Tablet;
  }
  public deviceMobile(): boolean {
    return this._deviceType === DeviceType.Handset;
  }

  private _deviceType = DeviceType.Unknown;
  public get deviceType(): DeviceType {
    return this._deviceType;
  }

  private _orientation = OrientationType.Unknown;
  public get orientation(): OrientationType {
    return this._orientation;
  }

  private readonly deviceAndOrientation = new Map([
    [Breakpoints.HandsetLandscape, BreakpointType.HandsetLandscape],
    [Breakpoints.HandsetPortrait, BreakpointType.HandsetPortrait],
    [Breakpoints.TabletLandscape, BreakpointType.TabletLandscape],
    [Breakpoints.TabletPortrait, BreakpointType.TabletPortrait],
    [Breakpoints.WebLandscape, BreakpointType.WebLandscape],
    [Breakpoints.WebPortrait, BreakpointType.WebPortrait],
  ]);

  private checkDeviceTypeAndOrientation(breakpointObserver: BreakpointObserver): void {
    breakpointObserver
      .observe([
        Breakpoints.HandsetLandscape,
        Breakpoints.HandsetPortrait,
        Breakpoints.WebLandscape,
        Breakpoints.WebPortrait,
        Breakpoints.TabletLandscape,
        Breakpoints.TabletPortrait,
      ])
      .subscribe((result: any) => {
        let orientationTypes = Object.keys(OrientationType).map((key) => key);

        let deviceTypes = Object.keys(DeviceType).map((key) => key);

        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            let type = this.deviceAndOrientation.get(query) ?? BreakpointType.Unknown;

            orientationTypes.forEach((element) => {
              if (type.indexOf(element) !== -1) this._orientation = element as OrientationType;
            });

            deviceTypes.forEach((element) => {
              if (type.indexOf(element) !== -1) this._deviceType = element as DeviceType;
            });
          }
        }
      });
  }

  public toggledSidenav(value?) {
    if (typeof value !== 'undefined') {
      this._isSidenavOpened.next(value);
    } else {
      this._isSidenavOpened.next(!this._isSidenavOpened.value);
    }
  }
}
